export default "__VITE_ASSET__DgtvDTBj__"